import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CodecraftQuizInstance } from '@codecraft-works/data-models';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { QuizService } from '../data-access/quiz.service';

@Component({
  standalone: true,
  selector: 'codecraft-quiz-table-title-link-cell',
  template: `
    <div>
      <!-- Review button for completed quizzes -->
      <button
        *ngIf="id && name && isQuizComplete()"
        class="btn btn-primary"
        (click)="reviewQuiz()"
      >
        Review
      </button>
      {{ name }}
      <!-- Resume button for incomplete quizzes -->
      <!-- <button
        *ngIf="id && name && !isQuizComplete()"
        class="btn btn-warning"
        (click)="resumeQuiz()"
      >
        Resume
      </button> -->
    </div>
  `,
  styles: [
    `
      a {
        text-decoration: none;
        color: inherit;
        font-weight: bold;
      }
    `,
  ],
  imports: [NgIf],
})
export class QuizTableTitleLinkCellComponent implements AgRendererComponent {
  quizInstance!: CodecraftQuizInstance;
  private quizService = inject(QuizService);
  name: string;
  id: string;
  quizType: string;

  refresh(params: ICellRendererParams): boolean {
    this.name = params.data.name;
    this.id = params.data.id;
    this.quizType = params.data.type;
    this.quizInstance = params.data.quizInstance as CodecraftQuizInstance;
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.name = params.data.name;
    this.id = params.data.id;
    this.quizType = params.data.type;
    this.quizInstance = params.data.quizInstance as CodecraftQuizInstance;
  }

  reviewQuiz() {
    this.quizService.initializeQuizReview(this.quizInstance);
  }

  resumeQuiz() {
    this.quizService.resumeQuiz(this.quizInstance);
  }

  isQuizComplete(): boolean {
    return !this.quizInstance.queue || this.quizInstance.queue.length === 0;
  }
}
